type RequestType = {
  loading: boolean;
  [key: string]: any;
};

export const checkForLoading = (requests: RequestType[]): boolean => {
  return requests.some(({ loading }) => loading);
};
